import { httpGet, httpPost } from '../../../utils/api.utils';
import { USER_ROLES_ID as userRoles } from '../../../utils/constant.utils';
import {
    getNavItems, setAllSubs, updateActiveKey,
    getBurgeMenuUrls, getNewNavItems
} from '../../../../app/constants/model-reducers/external/nav-menu/nav-menu.settings';

const initialState = {
    navItems: [],
    newNavItems: [],
    isSubsLoaded: false,
    isSubsError: false,
    activeKey: 0,
    subsUnderLineManager: [],
    burgerMenuUrls: [],
};

export const navMenuActions = {
    fetchBurgerMenuUrls: () => async (dispatch) => {
        var data = await httpGet('external/nav/getBurgerMenuUrls')
        dispatch({
            type: getBurgeMenuUrls,
            burgerMenuUrls: data
        });
    },
    fetchNavItems: () => async (dispatch, getState) => {
        var data = getState().navMenu.subsUnderLineManager;
        var url = 'external/nav/getNavMenus';
        var navItems = await httpPost(url, data);

        dispatch({
            type: getNavItems,
            navItems: navItems,
        });
        return Promise.resolve(true);
    },
    fetchNewNavItems: () => async (dispatch, getState) => {
        var data = {
            otherSubscribers: getState().navMenu.subsUnderLineManager
            , EId: sessionStorage.EID
        }
        var url = 'external/nav/getNewNavMenus';
        var newNavItems = await httpPost(url, data);

        dispatch({
            type: getNewNavItems,
            newNavItems: newNavItems,
        });
        return Promise.resolve(true);
    },
    updateActiveKey: activeKey => (dispatch, getState) => {
        dispatch({ type: updateActiveKey, activeKey: activeKey });
    },
    setSubsUnderLM: () => async (dispatch, getState) => {
        var isManager = (sessionStorage.UserRoleID == userRoles.manager || sessionStorage.UserRoleID == userRoles.lineManager);
        var subsUnderLineManager = [];
        if (isManager) {
            var empId = JSON.parse(sessionStorage.getItem('User')).Employee.EmployeeId;
            var subsUnderLineManager = await httpGet('external/otherSubscribers/getAllLevelSubscribers/' + empId);
        }

        var subsReady = (subsUnderLineManager.ok === false && isManager);
        dispatch({
            type: setAllSubs,
            isSubsLoaded: true,
            isSubsError: subsReady,
            subsUnderLineManager: subsReady ? [] : subsUnderLineManager
        });
        return Promise.resolve(true);
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getNavItems:
            return {
                ...state,
                navItems: action.navItems
            };
        case getNewNavItems:
            return {
                ...state,
                newNavItems: action.newNavItems
            };
        case setAllSubs:
            return {
                ...state,
                isSubsLoaded: action.isSubsLoaded,
                isSubsError: action.isSubsError,
                subsUnderLineManager: action.subsUnderLineManager
            };
        case updateActiveKey:
            return {
                ...state,
                activeKey: action.activeKey
            };
        case getBurgeMenuUrls:
            return {
                ...state,
                burgerMenuUrls: action.burgerMenuUrls
            };
        default:
            return state;
    }
};
